import React from 'react';
import { Auth } from 'aws-amplify';
import SocialIconAuth from './SocialIconAuth';
import LinkedInIcon from '../../ASUPhotos/icons/linkedin_socialicon.svg';
import GoogleIcon from '../../ASUPhotos/icons/google_socialicon.svg';

export const socialLoginIcons = ['google'];

export const handleFederatedSignIn = (providerName) => {
  return async (dispatch, getState) => {
    try {
      // Will let the user switch between social identity providers
      // await Credentials.clear();
      // Clear the current AWS credentials to allow the user to switch providers
      // await Auth.signOut();

      const state = getState();
      const authToken = state.auth.jwtToken;

      return await Auth.federatedSignIn({
        provider: providerName,
        token: authToken, // use customState for passing custom tokens
        expires_at: 1000 + new Date().getTime(), // the expiration timestamp
      });
    } catch (err) {
      console.log('Federated sign-in error: ', err);
    }
  };
};

export const socialIconIDMap = {
  linkedin: LinkedInIcon,
  google: GoogleIcon,
};

export const socialLabelIDMap = {
  linkedin: 'LinkedIn',
  google: 'Google',
};

export const checkSocialLogin = (userName, userIdentities) => {
  const validUserName = userName && userName.includes('google');

  const validUserIdentities =
    userIdentities && userIdentities.includes('Google');

  return validUserName || validUserIdentities;
};

export const getSocialIcon = (loginHandler, iconLabel, additionalClassName) => {
  return (
    <SocialIconAuth
      key={`${iconLabel}_icon`}
      handleSocialLogin={loginHandler}
      socialIconImage={socialIconIDMap[iconLabel]}
      socialIconLabel={socialLabelIDMap[iconLabel]}
      additionalClassName={additionalClassName}
    />
  );
};

export const isRogueTenantSSO = (tenantName, providerName) => {
  return (
    providerName && providerName.toLowerCase() !== tenantName.toLowerCase()
  );
};
